import React from 'react'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

export const desiredCredit = yup
  .number()
  .transform((value) => (Number.isNaN(value) ? Number.NaN : value))
  .nullable()
  .typeError('')
  .min(100000, () => (
    <FormattedMessage
      defaultMessage='Please enter amount of $1,000 or greater'
      id='sputnik.financeInfoSchema__8ojZQw'
    />
  ))
  .max(1500000000, () => (
    <FormattedMessage
      defaultMessage='Desired line of credit must be under $15,000,000'
      id='sputnik.financeInfoSchema__/rjj/A'
    />
  ))

export const expectedSpend = yup
  .number()
  .transform((value) => (Number.isNaN(value) ? Number.NaN : value))
  .nullable()
  .typeError('')
  .moreThan(0, () => (
    <FormattedMessage
      defaultMessage='The expected monthly spend must be greater than $0'
      id='sputnik.financeInfoSchema__KonQAT'
    />
  ))
  .lessThan(Number.MAX_SAFE_INTEGER, () => (
    <FormattedMessage
      defaultMessage='The amount is too high'
      id='sputnik.financeInfoSchema__awa+CK'
    />
  ))
